import Moveable from "moveable";
import type { Plugin } from "../core/plugin";
import { PluginRegistry } from "../core/pluginRegistry";

export class Resizable implements Plugin {
  constructor(private element: HTMLElement) {}

  init(): void {
    const moveable = new Moveable(document.body, {
      target: this.element,
      // If the container is null, the position is fixed. (default: parentElement(document.body))
      container: document.body,
      draggable: false,
      hideDefaultLines: true,
      resizable: {
        renderDirections: ["w", "e"],
      },
      scalable: false,
      rotatable: false,
      warpable: false,
      // Enabling pinchable lets you use events that
      // can be used in draggable, resizable, scalable, and rotateable.
      pinchable: ["resizable"],
      origin: false,
      keepRatio: true,
      // Resize, Scale Events at edges.
      edge: false,
      throttleDrag: 0,
      throttleResize: 0,
      throttleScale: 0,
      throttleRotate: 0,
    });
    moveable
      .on("resizeStart", () => {})
      .on("resize", ({ target, width, delta }) => {
        delta[0] && (target!.style.width = `${width}px`);
      })
      .on("resizeEnd", () => {});
  }
}

PluginRegistry.register("resizable", Resizable);
